/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EvaluationParameterLimitType = {
    Absolute: 'Absolute',
    WithoutEvaluation: 'WithoutEvaluation'
} as const;
export type EvaluationParameterLimitType = typeof EvaluationParameterLimitType[keyof typeof EvaluationParameterLimitType];


export function EvaluationParameterLimitTypeFromJSON(json: any): EvaluationParameterLimitType {
    return EvaluationParameterLimitTypeFromJSONTyped(json, false);
}

export function EvaluationParameterLimitTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationParameterLimitType {
    return json as EvaluationParameterLimitType;
}

export function EvaluationParameterLimitTypeToJSON(value?: EvaluationParameterLimitType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the EvaluationParameterLimitType interface.
 */
 export function instanceOfEvaluationParameterLimitType(value: any): value is EvaluationParameterLimitType {
    return Object.values(EvaluationParameterLimitType).includes(value)
}

